import MaterialTooltip from "../../../../__snowpack__/pkg/@mui/material/Tooltip.js";
import styled from "styled-components";
export const TooltipContainer = styled(MaterialTooltip).withConfig({
  displayName: "tooltipstyles__TooltipContainer",
  componentId: "sc-1fmrv1o-0"
})([""]);
